import { Heading } from '@slal/ui/typography';
import { mainContentId, mainContentTitleId } from '../utils';
import { StyledContent } from './styles';
import { ContentProps } from './types';

export const Content = ({ children, title, ...props }: ContentProps) => (
    <StyledContent id={mainContentId} role="main" aria-labelledby={mainContentTitleId} {...props}>
        {title && (
            <Heading id={mainContentTitleId} level={1}>
                {title}
            </Heading>
        )}
        {children}
    </StyledContent>
);
